import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance, findDomFromVNode } from 'intact-vue';
import { createContext } from '../context';
import { useDraggable } from '../../hooks/useDraggable';
export var context = createContext();
export function useResizable(scrollRef, tableRef, tableWidth, widthMap, storeWidth) {
  var instance = useInstance();
  var containerWidth;
  var x;
  var prevVNode;
  var prevTh;
  var prevMinWidth;
  var currentVNode;
  var currentTh;
  var currentMinWidth;
  var nextVNode;
  function onStart(e) {
    containerWidth = scrollRef.value.clientWidth;
    x = e.clientX;
    // find the previous column but exclude the hidden columns, #467
    prevVNode = nextVNode = currentVNode = e._vNode;
    prevTh;
    do {
      prevVNode = prevVNode.props.prevVNode;
      prevTh = findDomFromVNode(prevVNode, true);
    } while (window.getComputedStyle(prevTh).display === 'none');
    currentTh = findDomFromVNode(currentVNode, true);
    prevMinWidth = prevVNode.props.minWidth || instance.get('minColWidth');
    currentMinWidth = currentVNode.props.minWidth || instance.get('minColWidth');
    while (nextVNode = (_nextVNode = nextVNode) == null ? void 0 : _nextVNode.props.nextVNode) {
      var _nextVNode;
      var th = findDomFromVNode(nextVNode, true);
      if (window.getComputedStyle(th).display === 'none') {
        continue;
      }
      break;
    }
  }
  function onMove(e) {
    var _map;
    var delX = e.clientX - x;
    if (delX === 0) return;
    var newPrevWidth = prevTh.offsetWidth + delX;
    var newCurrentWidth = currentTh.offsetWidth - delX;
    var newTableWidth = tableRef.value.offsetWidth + delX;
    var isCurrentFixedRight = currentVNode.props.fixed === 'right';
    // const isPrevFixedRight = prevVNode.props!.fixed === 'right';
    if ((newPrevWidth < prevMinWidth || isCurrentFixedRight) && delX < 0) {
      // if (nextVNode) return;
      // the last column, we should expand its width
      if (newPrevWidth < prevMinWidth) {
        newPrevWidth -= delX;
        newTableWidth -= delX;
      }
    }
    var currentKey = currentVNode.props.key;
    var prevKey = prevVNode.props.key;
    var map = (_map = {}, _map[prevKey] = newPrevWidth, _map);
    if (!nextVNode || isCurrentFixedRight) {
      newTableWidth -= delX;
      if (newCurrentWidth < currentMinWidth && delX > 0) {
        newCurrentWidth = currentMinWidth;
      }
      map[currentKey] = newCurrentWidth;
    }
    x = e.clientX;
    if (containerWidth > newTableWidth) {
      map[currentKey] = newCurrentWidth;
    } else {
      tableWidth.set(newTableWidth);
    }
    widthMap.set(_extends({}, widthMap.value, map));
  }
  return useDraggable({
    onStart: onStart,
    onMove: onMove,
    onEnd: storeWidth
  });
}